import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import LocationEditor from '@blade-sxp/monitor/components/image-editor/image-editor.vue';
import { getMap } from '@blade-sxp/monitor/api/map';
let default_1 = class default_1 extends Vue {
    imgSrc = '';
    outerCircles = [];
    options = { radius: 15, drawCircleOption: { dashed: false } };
    formData = {
        location: undefined,
    };
    currVal = '0';
    detail;
    onDataChange(detail) {
        this.formData = { ...this.formData, ...detail };
        if (this.formData.location)
            this.outerCircles = [{ options: this.options, vertex: this.formData.location }];
    }
    handleDrawCircles(circles) {
        const last = circles.pop();
        this.outerCircles = [last];
        const { vertex } = last;
        this.formData.location = vertex;
    }
    async mounted() {
        this.formData = { ...this.formData, ...this.detail };
        if (this.formData.location)
            this.outerCircles = [{ options: this.options, vertex: this.formData.location }];
        const resp = await getMap();
        this.imgSrc = (resp && resp.data && resp.data.data) || '';
        if (!resp || !resp.data || resp.data.code !== 0)
            this.$message.error((resp && resp.data && resp.message) || `${this.$t('common.serverError')}`);
    }
};
__decorate([
    Prop()
], default_1.prototype, "detail", void 0);
__decorate([
    Watch('detail')
], default_1.prototype, "onDataChange", null);
default_1 = __decorate([
    Component({
        name: 'QueueStatistic',
        components: {
            LocationEditor,
        },
        i18n: {
            messages: {
                'en-us': {
                    mapRato: 'map Rate',
                },
                zh: {
                    mapRato: '底图比例',
                },
            },
        },
    })
], default_1);
export default default_1;
